import type { MixedStyleDeclaration } from 'react-native-render-html';

/** Merges submission-formatting tag styles with optional overrides (shallow per tag). */
export function mergeHtmlTagStyles(
  base: Record<string, MixedStyleDeclaration>,
  override?: Record<string, MixedStyleDeclaration>,
): Record<string, MixedStyleDeclaration> {
  if (!override) return base;
  const merged = { ...base };
  Object.entries(override).forEach(([tag, style]) => {
    merged[tag] = { ...merged[tag], ...style };
  });
  return merged;
}
